// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"TitleCard_conteiner__3qn5b"};